module.exports = __webpack_public_path__ + "img/esmeraldahotel.32c54b4f.png";